var _this = this;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import get from 'lodash/get';
import { sendToHost } from 'conversional-iframe-communication';
import { createComponentsFromObject } from 'conversional-components';
import { ResultsSelectors, useAppSelector } from 'conversional-journey';
import calls from 'conversional-callbacks';
import Result from './Result';
import { ResultError } from './ResultError';
// TODO: Replace feature of the URL event handler and remove this component entirely
// Instead move this logic to the result directly
var ResultPage = function (props) {
    var resultId = props.resultId;
    var result = useAppSelector(ResultsSelectors.selectResultsState);
    var error = useAppSelector(ResultsSelectors.selectResultError);
    React.useEffect(function () {
        var timer = setTimeout(function () {
            calls.urlEventsHandler();
        }, 300);
        return function () {
            clearTimeout(timer);
        };
    }, []);
    var supportedCallbacks = {
        closeCallback: function () { return sendToHost.destroy(); },
    };
    // Enable configuration-based callbacks in the root content element
    // Will need a more generich solution in future but is currently used in production
    React.useEffect(function () {
        var windowConf = get(result, 'content.root.Window', {});
        var customStyles = get(result, 'content.root.Window.iframeStyles');
        customStyles && sendToHost.styleIframe(customStyles, false);
        var cb = windowConf.callbacks;
        if (cb) {
            calls.addCallbacks(_this, cb, supportedCallbacks);
            return function () { return calls.removeCallbacks(_this, cb, supportedCallbacks); };
        }
    }, [result]);
    return (_jsx(_Fragment, { children: result && (!error || !error.status) ? (_jsx(Result, { children: createComponentsFromObject(result.content) })) : error ? (_jsx(ResultError, { status: error.status })) : null }));
};
export default ResultPage;
